import { all } from 'redux-saga/effects';

import { watchDevice } from './deviceSaga';
import { watchConfig } from './configSaga';
import { watchBase } from './baseSaga';
import { watchFilter } from './filterSaga';
import { watchTicketINC } from './ticketINCSaga';
import { watchTicketRITM } from './ticketRITMSaga';
import { watchTicketDetail } from './ticketDetailSaga';
import { watchKnowledgeDetail } from './knowledgeDetailSaga';
import { watchKnowledge } from './knowledgeSaga';
import { watchArticle } from './articleSaga';
import { watchSupportSearch } from './supportSearchSaga';
import { watchShippingAddress } from './shippingAddressSaga';
import { watchTicketApproval } from './ticketApprovalSaga';
import { watchUserPreferences } from './userPreferencesSaga';
import { watchTicketActivities } from './ticketActivitiesSaga';
import { watchOnBehalf } from './onBehalfSaga';
import { watchNotification } from './notificationSaga';
import { watchMarketplace } from './marketplaceSaga';
import { watchServiceRequest } from './serviceRequestSaga';
import { watchPcl } from './pclSaga';

export default function* rootSaga() {
  yield all([
    ...watchDevice,
    ...watchConfig,
    ...watchBase,
    ...watchFilter,
    ...watchTicketINC,
    ...watchTicketRITM,
    ...watchTicketDetail,
    ...watchKnowledgeDetail,
    ...watchKnowledge,
    ...watchArticle,
    ...watchSupportSearch,
    ...watchShippingAddress,
    ...watchTicketApproval,
    ...watchUserPreferences,
    ...watchTicketActivities,
    ...watchOnBehalf,
    ...watchNotification,
    ...watchMarketplace,
    ...watchServiceRequest,
    ...watchPcl,
  ])
}
